import React, { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../constants';
import * as D from '../deps';

import './BackstageLargeHeader.scss';

export interface IBackstageLargeHeaderOwnProps {
  dominantColor: string;
  useLightTheme: boolean;
  largeHeaderImageUrl: string;
  name: string;
  listenerCount: string;
  playPauseButton: ReactNode;
  isCuratorExperienceEnabled?: boolean;
}

export type IBackstageLargeHeaderProps = IBackstageLargeHeaderOwnProps;

export const BackstageLargeHeader: React.FC<IBackstageLargeHeaderProps> = props => {
  const {
    dominantColor,
    useLightTheme,
    largeHeaderImageUrl,
    name,
    listenerCount,
    playPauseButton,
    isCuratorExperienceEnabled,
  } = props;

  const classes = D.Utils.Css.createBEM('BackstageLargeHeader', {
    light: useLightTheme,
  });

  const artistSectionClasses = D.Utils.Css.createBEM('BackstageLargeHeader__artistSection', {
    // TODO: Presently, BackstageArtist is passing undefined to this createBEM
    // @ts-expect-error Type 'boolean | undefined' is not assignable to type 'boolean'
    curatorExperienceEnabled: isCuratorExperienceEnabled,
  });

  return (
    <header className={classes} style={{ backgroundImage: `url(${largeHeaderImageUrl})` }}>
      <section className={artistSectionClasses}>
        <h4 className='BackstageLargeHeader__artistName'>{name}</h4>
        <p className='BackstageLargeHeader__listenerCount'>{listenerCount}</p>
        <span className='BackstageLargeHeader__topSongs'>{playPauseButton}</span>
      </section>
      {!isCuratorExperienceEnabled && (
        <h5
          className='BackstageLargeHeader__ribbon'
          style={{ backgroundColor: `#${dominantColor}` }}
        >
          <FormattedMessage {...messages.exclusiveContent} values={{ name }} />
        </h5>
      )}
    </header>
  );
};

export default BackstageLargeHeader;
